import { LinkStyled } from 'commons/components';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { linkRoutes } from 'core/routes/routes';
import React from 'react';
import { ErrorContainer } from './error-app.style';

export const ErrorAppComponent: React.FC = () => (
    <ErrorContainer>
        <PocTypography variant="title1">404</PocTypography>
        <PocTypography variant="title3">Oops! Not Found</PocTypography>
        <LinkStyled to={linkRoutes.root}>Go to home</LinkStyled>
    </ErrorContainer>
);
